// @generated by protobuf-ts 2.6.0
// @generated from protobuf file "Common.proto" (package "CommonUsedMessages", syntax proto3)
// tslint:disable
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MESSAGE_TYPE } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message CommonUsedMessages.Point2D
 */
export interface Point2D {
    /**
     * @generated from protobuf field: double x = 1;
     */
    x: number;
    /**
     * @generated from protobuf field: double y = 2;
     */
    y: number;
}
/**
 * @generated from protobuf message CommonUsedMessages.Empty
 */
export interface Empty {
}
/**
 * @generated from protobuf message CommonUsedMessages.CommonStatus
 */
export interface CommonStatus {
    /**
     * @generated from protobuf field: bool statusValue = 1;
     */
    statusValue: boolean;
}
/**
 * @generated from protobuf message CommonUsedMessages.VPUStatus
 */
export interface VPUStatus {
    /**
     * @generated from protobuf field: bool statusValue = 1;
     */
    statusValue: boolean;
    /**
     * @generated from protobuf field: string error = 2;
     */
    error: string;
    /**
     * @generated from protobuf field: string result = 3;
     */
    result: string;
}
/**
 * @generated from protobuf message CommonUsedMessages.CHUProgressUpdate
 */
export interface CHUProgressUpdate {
    /**
     * @generated from protobuf field: string step = 1;
     */
    step: string;
    /**
     * @generated from protobuf field: int32 percentage = 2;
     */
    percentage: number;
}
/**
 * @generated from protobuf message CommonUsedMessages.DataChunkMessage
 */
export interface DataChunkMessage {
    /**
     * common data
     *
     * @generated from protobuf field: uint32 totalBytes = 1;
     */
    totalBytes: number;
    /**
     * @generated from protobuf field: uint32 totalChunks = 2;
     */
    totalChunks: number;
    /**
     * @generated from protobuf field: uint32 bytesPerChunk = 3;
     */
    bytesPerChunk: number;
    /**
     * current chunk data
     *
     * @generated from protobuf field: uint32 chunkIndex = 4;
     */
    chunkIndex: number;
    /**
     * @generated from protobuf field: uint32 chunkOffset = 5;
     */
    chunkOffset: number;
    /**
     * @generated from protobuf field: uint32 chunkSize = 6;
     */
    chunkSize: number;
    /**
     * @generated from protobuf field: bytes chunkContent = 7;
     */
    chunkContent: Uint8Array;
}
/**
 * @generated from protobuf message CommonUsedMessages.AdapterStatus
 */
export interface AdapterStatus {
    /**
     * @generated from protobuf field: CommonUsedMessages.AdapterStatus.Status connectionStatus = 1;
     */
    connectionStatus: AdapterStatus_Status;
    /**
     * @generated from protobuf field: int64 speedInBitsPs = 2;
     */
    speedInBitsPs: bigint;
    /**
     * @generated from protobuf field: CommonUsedMessages.AdapterStatus.CameraType cameraType = 3;
     */
    cameraType: AdapterStatus_CameraType;
}
/**
 * @generated from protobuf enum CommonUsedMessages.AdapterStatus.Status
 */
export enum AdapterStatus_Status {
    /**
     * @generated from protobuf enum value: CONNECTED = 0;
     */
    CONNECTED = 0,
    /**
     * @generated from protobuf enum value: DISCONNECTED = 1;
     */
    DISCONNECTED = 1,
    /**
     * @generated from protobuf enum value: DEGRADED = 2;
     */
    DEGRADED = 2,
    /**
     * @generated from protobuf enum value: EMPTY = 3;
     */
    EMPTY = 3
}
/**
 * @generated from protobuf enum CommonUsedMessages.AdapterStatus.CameraType
 */
export enum AdapterStatus_CameraType {
    /**
     * @generated from protobuf enum value: UNKNOWN_TYPE = 0;
     */
    UNKNOWN_TYPE = 0,
    /**
     * @generated from protobuf enum value: CHU = 1;
     */
    CHU = 1,
    /**
     * @generated from protobuf enum value: AA = 2;
     */
    AA = 2,
    /**
     * @generated from protobuf enum value: PIP = 3;
     */
    PIP = 3
}
/**
 * @generated from protobuf message CommonUsedMessages.CameraStatus
 */
export interface CameraStatus {
    /**
     * @generated from protobuf field: CommonUsedMessages.CameraStatus.Status connectionStatus = 1;
     */
    connectionStatus: CameraStatus_Status;
    /**
     * @generated from protobuf field: CommonUsedMessages.CameraStatus.CameraType cameraType = 2;
     */
    cameraType: CameraStatus_CameraType;
    /**
     * @generated from protobuf field: string cameraIp = 3;
     */
    cameraIp: string;
}
/**
 * @generated from protobuf enum CommonUsedMessages.CameraStatus.Status
 */
export enum CameraStatus_Status {
    /**
     * @generated from protobuf enum value: CONNECTED = 0;
     */
    CONNECTED = 0,
    /**
     * @generated from protobuf enum value: DISCONNECTED = 1;
     */
    DISCONNECTED = 1
}
/**
 * @generated from protobuf enum CommonUsedMessages.CameraStatus.CameraType
 */
export enum CameraStatus_CameraType {
    /**
     * @generated from protobuf enum value: UNKNOWN_TYPE = 0;
     */
    UNKNOWN_TYPE = 0,
    /**
     * @generated from protobuf enum value: CHU = 1;
     */
    CHU = 1,
    /**
     * @generated from protobuf enum value: AA = 2;
     */
    AA = 2,
    /**
     * @generated from protobuf enum value: PIP = 3;
     */
    PIP = 3
}
/**
 * @generated from protobuf message CommonUsedMessages.RtspLinkInfo
 */
export interface RtspLinkInfo {
    /**
     * @generated from protobuf field: CommonUsedMessages.RtspLinkCameraInfo cameraInfo = 1;
     */
    cameraInfo?: RtspLinkCameraInfo;
    /**
     * @generated from protobuf field: string rtspLink = 2;
     */
    rtspLink: string;
}
/**
 * @generated from protobuf message CommonUsedMessages.VenueCalibrationData
 */
export interface VenueCalibrationData {
    /**
     * @generated from protobuf field: string sportType = 1;
     */
    sportType: string;
    /**
     * @generated from protobuf field: int64 lastModifiedCalibration = 2;
     */
    lastModifiedCalibration: bigint;
    /**
     * @generated from protobuf field: CommonUsedMessages.BoolWrapper isPrimary = 3;
     */
    isPrimary?: BoolWrapper;
}
/**
 * @generated from protobuf message CommonUsedMessages.BoolWrapper
 */
export interface BoolWrapper {
    /**
     * @generated from protobuf field: bool value = 1;
     */
    value: boolean;
}
/**
 * @generated from protobuf message CommonUsedMessages.RtspLinkCameraInfo
 */
export interface RtspLinkCameraInfo {
    /**
     * @generated from protobuf field: CommonUsedMessages.RtspLinkCameraInfo.CameraType cameraType = 1;
     */
    cameraType: RtspLinkCameraInfo_CameraType;
    /**
     * @generated from protobuf field: int32 cameraIndex = 2;
     */
    cameraIndex: number;
    /**
     * @generated from protobuf field: string cameraIp = 3;
     */
    cameraIp: string;
}
/**
 * @generated from protobuf enum CommonUsedMessages.RtspLinkCameraInfo.CameraType
 */
export enum RtspLinkCameraInfo_CameraType {
    /**
     * @generated from protobuf enum value: UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: MAIN_CAMERA = 1;
     */
    MAIN_CAMERA = 1,
    /**
     * @generated from protobuf enum value: AA_CAMERA = 2;
     */
    AA_CAMERA = 2,
    /**
     * @generated from protobuf enum value: TACTICAL = 3;
     */
    TACTICAL = 3
}
// @generated message type with reflection information, may provide speed optimized methods
class Point2D$Type extends MessageType<Point2D> {
    constructor() {
        super("CommonUsedMessages.Point2D", [
            { no: 1, name: "x", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "y", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
    create(value?: PartialMessage<Point2D>): Point2D {
        const message = { x: 0, y: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<Point2D>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Point2D): Point2D {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* double x */ 1:
                    message.x = reader.double();
                    break;
                case /* double y */ 2:
                    message.y = reader.double();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Point2D, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* double x = 1; */
        if (message.x !== 0)
            writer.tag(1, WireType.Bit64).double(message.x);
        /* double y = 2; */
        if (message.y !== 0)
            writer.tag(2, WireType.Bit64).double(message.y);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CommonUsedMessages.Point2D
 */
export const Point2D = new Point2D$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Empty$Type extends MessageType<Empty> {
    constructor() {
        super("CommonUsedMessages.Empty", []);
    }
    create(value?: PartialMessage<Empty>): Empty {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<Empty>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Empty): Empty {
        return target ?? this.create();
    }
    internalBinaryWrite(message: Empty, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CommonUsedMessages.Empty
 */
export const Empty = new Empty$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CommonStatus$Type extends MessageType<CommonStatus> {
    constructor() {
        super("CommonUsedMessages.CommonStatus", [
            { no: 1, name: "statusValue", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<CommonStatus>): CommonStatus {
        const message = { statusValue: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<CommonStatus>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CommonStatus): CommonStatus {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool statusValue */ 1:
                    message.statusValue = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CommonStatus, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool statusValue = 1; */
        if (message.statusValue !== false)
            writer.tag(1, WireType.Varint).bool(message.statusValue);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CommonUsedMessages.CommonStatus
 */
export const CommonStatus = new CommonStatus$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VPUStatus$Type extends MessageType<VPUStatus> {
    constructor() {
        super("CommonUsedMessages.VPUStatus", [
            { no: 1, name: "statusValue", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "error", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "result", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<VPUStatus>): VPUStatus {
        const message = { statusValue: false, error: "", result: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<VPUStatus>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VPUStatus): VPUStatus {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool statusValue */ 1:
                    message.statusValue = reader.bool();
                    break;
                case /* string error */ 2:
                    message.error = reader.string();
                    break;
                case /* string result */ 3:
                    message.result = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VPUStatus, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool statusValue = 1; */
        if (message.statusValue !== false)
            writer.tag(1, WireType.Varint).bool(message.statusValue);
        /* string error = 2; */
        if (message.error !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.error);
        /* string result = 3; */
        if (message.result !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.result);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CommonUsedMessages.VPUStatus
 */
export const VPUStatus = new VPUStatus$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CHUProgressUpdate$Type extends MessageType<CHUProgressUpdate> {
    constructor() {
        super("CommonUsedMessages.CHUProgressUpdate", [
            { no: 1, name: "step", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "percentage", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<CHUProgressUpdate>): CHUProgressUpdate {
        const message = { step: "", percentage: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<CHUProgressUpdate>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CHUProgressUpdate): CHUProgressUpdate {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string step */ 1:
                    message.step = reader.string();
                    break;
                case /* int32 percentage */ 2:
                    message.percentage = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CHUProgressUpdate, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string step = 1; */
        if (message.step !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.step);
        /* int32 percentage = 2; */
        if (message.percentage !== 0)
            writer.tag(2, WireType.Varint).int32(message.percentage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CommonUsedMessages.CHUProgressUpdate
 */
export const CHUProgressUpdate = new CHUProgressUpdate$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DataChunkMessage$Type extends MessageType<DataChunkMessage> {
    constructor() {
        super("CommonUsedMessages.DataChunkMessage", [
            { no: 1, name: "totalBytes", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "totalChunks", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "bytesPerChunk", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 4, name: "chunkIndex", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 5, name: "chunkOffset", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 6, name: "chunkSize", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 7, name: "chunkContent", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value?: PartialMessage<DataChunkMessage>): DataChunkMessage {
        const message = { totalBytes: 0, totalChunks: 0, bytesPerChunk: 0, chunkIndex: 0, chunkOffset: 0, chunkSize: 0, chunkContent: new Uint8Array(0) };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<DataChunkMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DataChunkMessage): DataChunkMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 totalBytes */ 1:
                    message.totalBytes = reader.uint32();
                    break;
                case /* uint32 totalChunks */ 2:
                    message.totalChunks = reader.uint32();
                    break;
                case /* uint32 bytesPerChunk */ 3:
                    message.bytesPerChunk = reader.uint32();
                    break;
                case /* uint32 chunkIndex */ 4:
                    message.chunkIndex = reader.uint32();
                    break;
                case /* uint32 chunkOffset */ 5:
                    message.chunkOffset = reader.uint32();
                    break;
                case /* uint32 chunkSize */ 6:
                    message.chunkSize = reader.uint32();
                    break;
                case /* bytes chunkContent */ 7:
                    message.chunkContent = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DataChunkMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 totalBytes = 1; */
        if (message.totalBytes !== 0)
            writer.tag(1, WireType.Varint).uint32(message.totalBytes);
        /* uint32 totalChunks = 2; */
        if (message.totalChunks !== 0)
            writer.tag(2, WireType.Varint).uint32(message.totalChunks);
        /* uint32 bytesPerChunk = 3; */
        if (message.bytesPerChunk !== 0)
            writer.tag(3, WireType.Varint).uint32(message.bytesPerChunk);
        /* uint32 chunkIndex = 4; */
        if (message.chunkIndex !== 0)
            writer.tag(4, WireType.Varint).uint32(message.chunkIndex);
        /* uint32 chunkOffset = 5; */
        if (message.chunkOffset !== 0)
            writer.tag(5, WireType.Varint).uint32(message.chunkOffset);
        /* uint32 chunkSize = 6; */
        if (message.chunkSize !== 0)
            writer.tag(6, WireType.Varint).uint32(message.chunkSize);
        /* bytes chunkContent = 7; */
        if (message.chunkContent.length)
            writer.tag(7, WireType.LengthDelimited).bytes(message.chunkContent);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CommonUsedMessages.DataChunkMessage
 */
export const DataChunkMessage = new DataChunkMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AdapterStatus$Type extends MessageType<AdapterStatus> {
    constructor() {
        super("CommonUsedMessages.AdapterStatus", [
            { no: 1, name: "connectionStatus", kind: "enum", T: () => ["CommonUsedMessages.AdapterStatus.Status", AdapterStatus_Status] },
            { no: 2, name: "speedInBitsPs", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "cameraType", kind: "enum", T: () => ["CommonUsedMessages.AdapterStatus.CameraType", AdapterStatus_CameraType] }
        ]);
    }
    create(value?: PartialMessage<AdapterStatus>): AdapterStatus {
        const message = { connectionStatus: 0, speedInBitsPs: 0n, cameraType: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<AdapterStatus>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AdapterStatus): AdapterStatus {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* CommonUsedMessages.AdapterStatus.Status connectionStatus */ 1:
                    message.connectionStatus = reader.int32();
                    break;
                case /* int64 speedInBitsPs */ 2:
                    message.speedInBitsPs = reader.int64().toBigInt();
                    break;
                case /* CommonUsedMessages.AdapterStatus.CameraType cameraType */ 3:
                    message.cameraType = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AdapterStatus, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* CommonUsedMessages.AdapterStatus.Status connectionStatus = 1; */
        if (message.connectionStatus !== 0)
            writer.tag(1, WireType.Varint).int32(message.connectionStatus);
        /* int64 speedInBitsPs = 2; */
        if (message.speedInBitsPs !== 0n)
            writer.tag(2, WireType.Varint).int64(message.speedInBitsPs);
        /* CommonUsedMessages.AdapterStatus.CameraType cameraType = 3; */
        if (message.cameraType !== 0)
            writer.tag(3, WireType.Varint).int32(message.cameraType);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CommonUsedMessages.AdapterStatus
 */
export const AdapterStatus = new AdapterStatus$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CameraStatus$Type extends MessageType<CameraStatus> {
    constructor() {
        super("CommonUsedMessages.CameraStatus", [
            { no: 1, name: "connectionStatus", kind: "enum", T: () => ["CommonUsedMessages.CameraStatus.Status", CameraStatus_Status] },
            { no: 2, name: "cameraType", kind: "enum", T: () => ["CommonUsedMessages.CameraStatus.CameraType", CameraStatus_CameraType] },
            { no: 3, name: "cameraIp", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CameraStatus>): CameraStatus {
        const message = { connectionStatus: 0, cameraType: 0, cameraIp: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<CameraStatus>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CameraStatus): CameraStatus {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* CommonUsedMessages.CameraStatus.Status connectionStatus */ 1:
                    message.connectionStatus = reader.int32();
                    break;
                case /* CommonUsedMessages.CameraStatus.CameraType cameraType */ 2:
                    message.cameraType = reader.int32();
                    break;
                case /* string cameraIp */ 3:
                    message.cameraIp = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CameraStatus, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* CommonUsedMessages.CameraStatus.Status connectionStatus = 1; */
        if (message.connectionStatus !== 0)
            writer.tag(1, WireType.Varint).int32(message.connectionStatus);
        /* CommonUsedMessages.CameraStatus.CameraType cameraType = 2; */
        if (message.cameraType !== 0)
            writer.tag(2, WireType.Varint).int32(message.cameraType);
        /* string cameraIp = 3; */
        if (message.cameraIp !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.cameraIp);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CommonUsedMessages.CameraStatus
 */
export const CameraStatus = new CameraStatus$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RtspLinkInfo$Type extends MessageType<RtspLinkInfo> {
    constructor() {
        super("CommonUsedMessages.RtspLinkInfo", [
            { no: 1, name: "cameraInfo", kind: "message", T: () => RtspLinkCameraInfo },
            { no: 2, name: "rtspLink", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<RtspLinkInfo>): RtspLinkInfo {
        const message = { rtspLink: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<RtspLinkInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RtspLinkInfo): RtspLinkInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* CommonUsedMessages.RtspLinkCameraInfo cameraInfo */ 1:
                    message.cameraInfo = RtspLinkCameraInfo.internalBinaryRead(reader, reader.uint32(), options, message.cameraInfo);
                    break;
                case /* string rtspLink */ 2:
                    message.rtspLink = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RtspLinkInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* CommonUsedMessages.RtspLinkCameraInfo cameraInfo = 1; */
        if (message.cameraInfo)
            RtspLinkCameraInfo.internalBinaryWrite(message.cameraInfo, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string rtspLink = 2; */
        if (message.rtspLink !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.rtspLink);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CommonUsedMessages.RtspLinkInfo
 */
export const RtspLinkInfo = new RtspLinkInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VenueCalibrationData$Type extends MessageType<VenueCalibrationData> {
    constructor() {
        super("CommonUsedMessages.VenueCalibrationData", [
            { no: 1, name: "sportType", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "lastModifiedCalibration", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "isPrimary", kind: "message", T: () => BoolWrapper }
        ]);
    }
    create(value?: PartialMessage<VenueCalibrationData>): VenueCalibrationData {
        const message = { sportType: "", lastModifiedCalibration: 0n };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<VenueCalibrationData>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VenueCalibrationData): VenueCalibrationData {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string sportType */ 1:
                    message.sportType = reader.string();
                    break;
                case /* int64 lastModifiedCalibration */ 2:
                    message.lastModifiedCalibration = reader.int64().toBigInt();
                    break;
                case /* CommonUsedMessages.BoolWrapper isPrimary */ 3:
                    message.isPrimary = BoolWrapper.internalBinaryRead(reader, reader.uint32(), options, message.isPrimary);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VenueCalibrationData, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string sportType = 1; */
        if (message.sportType !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.sportType);
        /* int64 lastModifiedCalibration = 2; */
        if (message.lastModifiedCalibration !== 0n)
            writer.tag(2, WireType.Varint).int64(message.lastModifiedCalibration);
        /* CommonUsedMessages.BoolWrapper isPrimary = 3; */
        if (message.isPrimary)
            BoolWrapper.internalBinaryWrite(message.isPrimary, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CommonUsedMessages.VenueCalibrationData
 */
export const VenueCalibrationData = new VenueCalibrationData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BoolWrapper$Type extends MessageType<BoolWrapper> {
    constructor() {
        super("CommonUsedMessages.BoolWrapper", [
            { no: 1, name: "value", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<BoolWrapper>): BoolWrapper {
        const message = { value: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<BoolWrapper>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BoolWrapper): BoolWrapper {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool value */ 1:
                    message.value = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BoolWrapper, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool value = 1; */
        if (message.value !== false)
            writer.tag(1, WireType.Varint).bool(message.value);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CommonUsedMessages.BoolWrapper
 */
export const BoolWrapper = new BoolWrapper$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RtspLinkCameraInfo$Type extends MessageType<RtspLinkCameraInfo> {
    constructor() {
        super("CommonUsedMessages.RtspLinkCameraInfo", [
            { no: 1, name: "cameraType", kind: "enum", T: () => ["CommonUsedMessages.RtspLinkCameraInfo.CameraType", RtspLinkCameraInfo_CameraType] },
            { no: 2, name: "cameraIndex", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "cameraIp", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<RtspLinkCameraInfo>): RtspLinkCameraInfo {
        const message = { cameraType: 0, cameraIndex: 0, cameraIp: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<RtspLinkCameraInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RtspLinkCameraInfo): RtspLinkCameraInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* CommonUsedMessages.RtspLinkCameraInfo.CameraType cameraType */ 1:
                    message.cameraType = reader.int32();
                    break;
                case /* int32 cameraIndex */ 2:
                    message.cameraIndex = reader.int32();
                    break;
                case /* string cameraIp */ 3:
                    message.cameraIp = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RtspLinkCameraInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* CommonUsedMessages.RtspLinkCameraInfo.CameraType cameraType = 1; */
        if (message.cameraType !== 0)
            writer.tag(1, WireType.Varint).int32(message.cameraType);
        /* int32 cameraIndex = 2; */
        if (message.cameraIndex !== 0)
            writer.tag(2, WireType.Varint).int32(message.cameraIndex);
        /* string cameraIp = 3; */
        if (message.cameraIp !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.cameraIp);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CommonUsedMessages.RtspLinkCameraInfo
 */
export const RtspLinkCameraInfo = new RtspLinkCameraInfo$Type();
